<rid-demo-page [title]="'Formule'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Flitsen met getallen" routerLink="flash-number" variant="PRIMARY" />
  <rid-button class="w-full" content="Flits tellen" routerLink="flash-counting" variant="PRIMARY" />
  <rid-button class="w-full" content="Flits tellen (categorized)" routerLink="flash-counting-categorized" variant="PRIMARY" />
  <rid-button class="w-full" content="Flits hoeveelheid" routerLink="flash-amount" variant="PRIMARY" />
  <rid-button class="w-full" content="Getallen Splitsen" routerLink="splitting" variant="PRIMARY" />
  <rid-button class="w-full" content="Sommen" routerLink="math" variant="PRIMARY" />
  <rid-button class="w-full" content="Getallen Schrijven" routerLink="number-writing" variant="PRIMARY" />
  <rid-button class="w-full" content="Vergelijken" routerLink="compare" variant="PRIMARY" />
  <rid-button class="w-full" content="Eierdozen" routerLink="egg-carton-sums" variant="PRIMARY" />
  <rid-button class="w-full" content="Eierdozen (klikken)" routerLink="egg-carton-sums-click" variant="PRIMARY" />
</rid-demo-page>
